import Swiper, {Autoplay} from 'swiper';

Swiper.use([Autoplay]);

export default () => {
    let container = document.querySelector('.about-who-we-are-content-right__slider');
    if (container) {
        let aboutSlider = slider(container);
    }
}

let slider = (container) => {
    let swiper = new Swiper(container, {
        slidesPerView: 1,
        loop: true,
        direction: 'vertical',
        calculateHeight: true,
        autoplay: {
            delay: 5000,
            disableOnInteraction: true,
        },
        breakpoints: {
            768: {
                loop: true,
                slidesPerView: 2,
            },
            992: {
                loop: true,
                slidesPerView: 3,
            }
        }
    });
    return swiper;
}
